import { FC, useCallback, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UsersListItemProps } from "./UsersListItem.types";
import { ReactComponent as DeleteIconSvg } from "images/TrashCan.svg";
import { ReactComponent as ReestablishIconSvg } from "images/reestablish.svg";
import { ReactComponent as ActionMenuIconSvg } from "../../images/ActionMenuIcon.svg";
import DropSelect from "components-new/DropSelect";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import { useAppDispatch } from "toolkit/hooks";
import { getUsers } from "toolkit/users/users.thunks";
import cn from "classnames";
import styles from "./UsersListItem.module.sass";
import { snackWrapper } from "helpers";
import {userAPI} from "../../libs/apiClient/User";

export const UsersListItem: FC<UsersListItemProps> = ({ user, searchValue, read, archive, select, outline }) => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const locationState = useLocation().state;

	const [actionsVisible, setActionsVisible] = useState<boolean>(false);

	const actionsRef = useRef(null);

	useOutsideAlerter(actionsRef.current, () => setActionsVisible(false));

	const connectEntity = useCallback(() => {
		if (select) {
			const params = { employeeid: locationState.id, userid: user.id };
			userAPI.profileBindList( params ).then(() => navigate(-1));
		}
		//eslint-disable-next-line
	}, [locationState]);

	const archiveUser = () => {
		userAPI.archiveCreate(user.id)
			.then(() => {
				snackWrapper("success", "Пользователь успешно архивирован");
				dispatch(getUsers({ searchValue, filter_active: !archive }));
			})
			.catch(() => {
				snackWrapper("error", "Не удалось восстановить пользователя");
			});
	};

	const unArchiveUser = () => {
		userAPI.unArchiveCreate(user.id)
			.then(() => {
				snackWrapper("success", "Пользователь успешно восстановлен");
				dispatch(getUsers({ searchValue, filter_active: !archive }));
			})
			.catch(() => {
				snackWrapper("error", "Не удалось архивировать пользователя");
			});
	};
	const needRule = () => {
		snackWrapper("error", "Не достаточно прав");
	};
	return (
		<>
			<div
				className={cn(styles.rowBox, outline(user.id))}
				onClick={() => {
					if (select) {
						connectEntity();
					}
				}}>
				<div className={styles.row}>
					<div className={styles.item}>{user.id}</div>
					<div className={cn(styles.item, { [styles.link]: !select })}>
						{select ? (
							<span>
								{user.lastName} {user.firstName} {user.middleName}
							</span>
						) : read ? (
							<Link to={`/user/${user.id}`} className={styles.link}>
								{user.lastName} {user.firstName} {user.middleName}
							</Link>
						) : (
							<span onClick={needRule}>
								{user.lastName} {user.firstName} {user.middleName}
							</span>
						)}
					</div>
					{select ? (
						<div className={cn(styles.item, styles.link, styles.roleLink)}>{user.role || "Задать роль"}</div>
					) : (
						<Link
							to={`/references/users/${user.id}/roles/`}
							className={styles.roleLink}
							state={{
								firstName: user.firstName,
								middleName: user.middleName,
								lastName: user.lastName,
							}}>
							<div className={cn(styles.item, styles.link)}>{user.role || "По умолчанию"}</div>
						</Link>
					)}
					<div className={styles.item}>{user.email || "—"}</div>
					<div className={styles.item}>{user.tabNumber || "—"}</div>
					<div className={styles.item}>{user.position || "—"}</div>
					<div className={styles.item}>{user.status || "—"}</div>
					<div className={styles.item}>
						{select ? (
							<div>{user.organization?.fullName || "—"}</div>
						) : user.organization?.id ? (
							<Link to={`/organization/${user.organization?.id}`} className={styles.link}>
								{user.organization?.fullName || "—"}
							</Link>
						) : (
							<div>{user.organization?.fullName || "—"}</div>
						)}
					</div>
				</div>
				{!select && (
					<ActionMenuIconSvg
						className={styles.actionsIcon}
						ref={actionsRef}
						onClick={() => setActionsVisible((prevState) => !prevState)}
					/>
				)}
			</div>

			{actionsVisible && (
				<DropSelect target={actionsRef.current} position="right">
					<div className="staff-table-action-menu">
						<button className="staff-table-action-menu-btn" onClick={archive ? unArchiveUser : archiveUser}>
							{archive ? (
								<div className={styles.menu}>
									<div>
										<ReestablishIconSvg className="staff-table-action-menu-btn-reestablishIcon" />
									</div>
									<span className="staff-table-action-menu-btn-txt">Восстановить</span>
								</div>
							) : (
								<div className={styles.menu}>
									<div>
										<DeleteIconSvg className="staff-table-action-menu-btn-deleteIcon" />
									</div>
									<span className="staff-table-action-menu-btn-txt">Переместить в архив</span>
								</div>
							)}
						</button>
					</div>
				</DropSelect>
			)}
		</>
	);
};
